import { render } from "./VerificationOTP.vue?vue&type=template&id=fae6b3fa"
import script from "./VerificationOTP.vue?vue&type=script&lang=js"
export * from "./VerificationOTP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__